import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer>
      <p>&copy; 2024 Palindrome Coaching LLC. All rights reserved.</p>
    </footer>
  );
}

export default Footer;